export default {"src":"/_next/static/media/dwg-icon.4d982f51.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};